import { getAuth } from 'firebase/auth';
import { useContext, useMemo } from 'react';
import { ParentContext } from '../ParentContext';
import { AppContext } from '../AppProvider';
import { PapsContext } from '../PapsContext';

const _forceTs = false

export const _hostNames = {
  thumbstat: 'thumbstat.com',
}

export const _hostPaths = {
  thumstat: '/clients/b4C6wHP0A5AgQPTD78ue/events/pojoSports/organizations/BjY3VqQ3lUBQ9PXDyXCl/districts/qJOYke2iCxxT8RppMcsc/sports/V8h4h1sJDQpc4Mb969ko'
}

export const useHost = () => {

  const _host = document.location.host

  const appContext = useContext(AppContext)
  const { app_state } = appContext ?? {}
  const { mainApp, app_ts } = app_state ?? {}

  const papsContext = useContext(PapsContext)
  const { paps_state } = papsContext ?? {}
  const { pathViews } = paps_state ?? {}

  return useMemo(() => {
    let _currentApp = mainApp
    if (_forceTs && pathViews?.events === 'pojoSports') {
      _currentApp = app_ts.app
    } else {
      switch (_host) {
        case _hostNames.thumbstat:
          _currentApp = app_ts.app
          break;
        default:
        // nothing
      }
    }

    const auth_current = getAuth(_currentApp);
    return auth_current
  }, [pathViews])

}
